import React from "react";
import Banner from "../common/Banner";
import aboutdata from "../../data/about.json"


const About = () => {
  return (
   
    <>
      <Banner
        title={aboutdata?.banner?.title || "About"}
        currentLabel={aboutdata?.banner?.breadcrumb || "About"}
      />

    </>
  );
};

export default About;